// extracted by mini-css-extract-plugin
export var actionIcon = "_tu-0";